import { FileToLanguage } from '../../../covance-file-upload/covance-file-upload.component';

export class EQueryReopenData {
    constructor(public reason: string, public comments: string, public files: FileToLanguage) {}
}
